var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ref === 'paragraph')?_c('p',{ref:"paragraph",class:_vm.classes}):(_vm.ref === 'words')?_c('span',{ref:"words",class:_vm.classes}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }